/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

export const CoverImageStyle: any = {
  backgroundSize: 'cover',
  backgroundRepeat: 'no-repeat',
  backgroundAttachment: 'fixed',
  borderRadius: '30px',
};

export const imageStyle: any = {
  width: '40vw',
  height: '300px',
  objectFit: 'cover',
  borderRadius: '20px',
  cursor: 'pointer',
};

export const CarouselItemContainer: any = {
  marginRight: '20px',
  marginTop: '10px',
  marginBottom: '20px',
};

export const DocumentContainer: any = {
  marginTop: '0px',
  alignSelf: 'center',
  alignItems: 'center',
  justifyContent: 'center',
};
